import React, { useEffect } from "react";
import { motion } from "framer-motion";
import AOS from "aos";
import "aos/dist/aos.css";
import "./tools.css";

import one from "../../assets/devopsimages/tool/ansible.png";
import two from "../../assets/devopsimages/tool/azuredevops.png";
import three from "../../assets/devopsimages/tool/chef.png";
import four from "../../assets/devopsimages/tool/dockers.png";
import five from "../../assets/devopsimages/tool/git.png";
import six from "../../assets/devopsimages/tool/gradle.png";
import seven from "../../assets/devopsimages/tool/jenkins.png";
import eight from "../../assets/devopsimages/tool/jira.png";
import nine from "../../assets/devopsimages/tool/katalon.png";
import ten from "../../assets/devopsimages/tool/kubernets.png";
import elven from "../../assets/devopsimages/tool/ranorex.png";
import twele from "../../assets/devopsimages/tool/raygun.png";
import thirteen from "../../assets/devopsimages/tool/terllo.png";
import fourteen from "../../assets/devopsimages/tool/terraform.png";
import fifteen from "../../assets/devopsimages/tool/testops.png";
// import sixteen from "../../assets/devopsimages/tool/raygun.png";



const clients = [
  { src: one, alt: "Apache JMeter" },
  { src: two, alt: "Appium" },
  { src: three, alt: "Appium JPG" },
  { src: four, alt: "Cucumber" },
  { src: five, alt: "Java" },
  { src: six, alt: "Jenkins" },
  { src: seven, alt: "JUnit" },
  { src: eight, alt: "LoadRunner" },
  { src: nine, alt: "Postman" },
  { src: ten, alt: "Selenium" },
  { src: elven, alt: "SoapUI" },
  { src: twele, alt: "TestNG" },
  { src: thirteen, alt: "Selenium" },
  { src: fourteen, alt: "SoapUI" },
  { src: fifteen, alt: "TestNG" },
];

function Tools() {
  useEffect(() => {
    AOS.init({ duration: 800, once: true });
  }, []);

  return (
    <>
      <section style={{ marginTop: "50px" }}>
        <div className="headlines-for-all">
          <h4 data-aos="fade-up" >
            <span>Tools </span> Covered
          </h4>
          <p data-aos="fade-up">
            Gain hands-on experience with the most in-demand DevOps tools, cloud platforms, and CI/CD practices used to automate modern software delivery.
          </p>
        </div>
      </section>

      <section className="our-clients-section">
        <div className="our-clients-container">
          <motion.div
            className="our-clients-track"
            animate={{ x: ["0%", "-100%"] }}
            transition={{
              ease: "linear",
              duration: 100,
              repeat: Infinity,
            }}
          >
            {[...clients, ...clients].map((client, i) => (
              <div
                className="client-item"
                key={i}
                data-aos="fade-up"
                data-aos-delay={i * 150} // DELAY ONE-BY-ONE
              >
                <img src={client.src} alt={client.alt} />
              </div>
            ))}
          </motion.div>
        </div>
      </section>
    </>
  );
}

export default Tools;
